import { memo } from "react";
import { getContrastColor } from "@miplatform/utils";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";

interface OptionChipProps {
  backgroundColor: string;
  shortName: string;
  label: string;
}

export const OptionChip = memo(
  ({ backgroundColor, shortName, label }: OptionChipProps) => (
    <Box display="flex" alignItems="center" gap={1} width="100%" height={22}>
      <Box
        sx={(theme) => ({
          borderRadius: theme.spacing(0.5),
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: 30,
          height: 20,
          backgroundColor,
        })}
      >
        <Typography
          sx={(theme) => ({
            color: getContrastColor(backgroundColor),
            fontSize: theme.typography.pxToRem(10),
          })}
        >
          {shortName}
        </Typography>
      </Box>
      <Typography>{label}</Typography>
    </Box>
  )
);
